<template>
  <div>
    <nav>
      <img @click="goToRoot()"
           src="../../assets/img/logo_falabella.svg"
           class="fb-logo"
           alt="Falabella">
      <template v-if="isApp">
        <el-dropdown @command="sessionCommand">
        <span class=" item el-dropdown-link">
          <Flag :code="countryCode"
                :height="21"
                class="flag"/>
          MI SESIÓN<i class="el-icon-arrow-down el-icon--right"/>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">Cerrar</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="separator"></span>
        <span class="item"
              @click="getProgress">PROCESOS</span>
        <span v-if="accessQueues"
              class="item"
              @click="goTo('Queues')">COLAS</span>
      </template>
    </nav>
    <el-drawer
      title="Seguimiento de procesos"
      :visible.sync="drawer"
      :direction="direction"
      class="drawer-block">
      <div class="block">
        <el-tree
          :data="logs"
          v-loading="logLoad"
          empty-text=""
          :props="defaultProps"
          :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>{{ node.label.includes('::') ?
                node.label.split('::')[2] + " " + node.label.split('::')[1] : node.label }}</span>
              <span v-if="node.level === 1">
                <i v-if="node.label.split('@')[0] === '1' || node.label.split('@')[0] === '0'"
                   class="fas fa-spinner fa-pulse"/>
                <i v-else-if="node.label.split('@')[0] === '3'"
                   class="far fa-check-circle falabella-green"/>
                <i v-else-if="node.label.split('@')[0] === '2'"
                   class="far fa-times-circle falabella-red"/>
              </span>
            </span>
        </el-tree>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Flag from '@/app/components/base/Flag.vue';
import { clearRumUserContext } from '@/observability/datadogRum';
import { tenantCode } from '@/mixins/tenants';
import { decodeRSA } from '../../mixins/function';
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'TheNavbar',
  components: {
    Flag,
  },
  data() {
    return {
      direction: 'rtl',
      drawer: false,
      isLog: true,
      datitos: [],
      logs: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        _type: '_type',
        status: 'status',
      },
    };
  },
  methods: {
    goTo(name) {
      if (this.$route.name !== name) this.$router.replace({ name });
    },
    goToRoot() {
      if (this.isApp) this.goTo('Home');
      else this.$router.go('/login');
    },
    sessionCommand(c) {
      if (c === 'logout') {
        clearRumUserContext();
        sessionStorage.clear();
        this.$router.replace('/login');
      } else if (c === 'refresh') {
        this.$emit('refresh');
      }
    },
    getProgress() {
      this.drawer = true;
      sessionStorage.setItem('isLog', JSON.parse(false));
      this.isLog = false;
      apiRequest({
        module: 'crud',
        service: 'get_logs',
      }).then((res) => {
        this.datitos = [];
        res.data.tasks.forEach((data) => {
          const process = [];
          let finalStatus = 0;
          data.process.forEach((p) => {
            const item = { label: p.log_info };
            if (p.detail !== '') {
              item.children = [{ label: p.detail }];
            }
            process.push(item);
            if (p.status === 2) {
              finalStatus = 2;
            } else if (p.status > finalStatus && finalStatus !== 2) {
              finalStatus = p.status;
            }
          });
          const aux = {
            label: finalStatus.toString(10).concat('@', data.name),
            _type: 'status',
            status: finalStatus,
            children: process,
          };
          this.datitos.push(aux);
          this.logs = JSON.parse(JSON.stringify(this.datitos));
        });
      }).catch(() => null);
    },
  },
  computed: {
    isApp() {
      return this.$route.name !== 'Login' && this.$route.name !== 'Register';
    },
    accessQueues() {
      return ['1', '2'].includes(decodeRSA(sessionStorage.type));
    },
    countryCode() {
      return this.isApp ? tenantCode() : '';
    },
    logLoad() {
      return this.logs.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  nav {
    height: 47px;
    padding-right: 10px;
    letter-spacing: 0.3px;
    border-top: 3px solid $fb-green;
    background-color: $fb-grey-dark-50;
    box-shadow: 3px 0 10px 0 rgba(74, 74, 74, 0.15);
    .fb-logo {
      width: 59px;
      z-index: 12;
      float: left;
      height: 68px;
      cursor: pointer;
      position: relative;
      padding-bottom: 29px;
    }
    span, .el-dropdown {
      float: right;
      user-select: none;
    }
    .item {
      height: 15px;
      font-size: 12px;
      cursor: pointer;
      color: $fb-grey-light-50;
      padding: 16px 10px;
      .fas {
        font-size: 14px;
        margin-right: 8px;
        float: left !important;
      }
      .fa-check-circle { color: $fb-green; }
      .fa-exclamation-circle { color: $fb-red; }
      .fa-exclamation-triangle { color: $fb-amber; }
      .badge {
        float: left;
        width: 9px;
        height: 9px;
        margin: 3px 8px 0 0;
        border-radius: 13px;
        background-color: $fb-green;
      }
      .flag {
        float: left;
        margin-top: -3px;
      }
    }
    .item:hover {
      color: white;
      text-decoration: underline;
    }
    .separator {
      height: 19px;
      margin: 14px 7px;
      border-left: 1px solid $fb-grey-light-10;
    }
  }
  .confirm {
    padding: 0 !important;
    .popover-title {
      font-size: 16px;
      text-align: left;
      padding-top: 8px;
      i {
        font-size: 20px;
        margin-right: 8px;
        color: $fb-green;
      }
    }
    .popover-footer {
      padding-top: 28px;
      text-align: right;
      padding-bottom: 4px;
    }
    .popover-title, .popover-footer {
      padding-left: 6px;
      padding-right: 6px;
    }
  }
</style>
